import Link from 'next/link'
import styles from '../CaseStudyLarge.module.scss'
import { useEffect, useRef } from 'react'
import Slider from 'react-slick'

export interface CaseStudySliderItemSP {
  src: string
  logo: string
  title: string
  problem: string
  caseName: string
  client: string
  term: string
  overview: string
}

interface Props {
  caseStudySliderList: CaseStudySliderItemSP[]
}

const MobileCaseStudyItem: React.FC<Props> = ({ caseStudySliderList }) => {
  const sliderRef = useRef(null)

  const settings = {
    dots: true,
    arrows: false,
    centerMode: true,
    infinite: true,
    centerPadding: '120px',
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          centerPadding: '153px',
        },
      },
      {
        breakpoint: 719,
        settings: {
          slidesToShow: 1,
          centerPadding: '50px',
        },
      },
      {
        breakpoint: 690,
        settings: {
          slidesToShow: 1,
          centerPadding: '50px',
        },
      },
    ],
    onInit: () => setEqualHeight(),
    onReInit: () => setEqualHeight(),
  }

  // スライドの高さを揃えるための関数
  const setEqualHeight = () => {
    if (!sliderRef.current) return

    let maxHeight = 0
    const slides = sliderRef.current.querySelectorAll('.slick-slide')

    slides.forEach((slide) => {
      slide.style.height = 'auto' // 高さをリセット
      const height = slide.clientHeight
      maxHeight = Math.max(maxHeight, height) // 最大高さを更新
    })

    slides.forEach((slide) => {
      slide.style.height = `${maxHeight}px` // 全スライドに最大高さを適用
    })
  }

  useEffect(() => {
    setEqualHeight()
    window.addEventListener('resize', setEqualHeight)

    return () => {
      window.removeEventListener('resize', setEqualHeight)
    }
  }, [])

  return (
    <Slider {...settings}>
      {caseStudySliderList.map(
        (item) => (
          <div className={styles.casescard} key={item.title}>
            <div className={styles.casescard_img}>
              <img src={item.src} alt={item.src} />
            </div>
            <div className={styles.casescard_label}>
              <div className={styles.casescard_logo_container}>
                <img src={item.logo} alt="" />
              </div>
              <p className={styles.casescard_label_title}>{item.title}</p>
              <div className={styles.casescard_problem_container}>
                <p>Problem/Want</p>
                <p>
                  <span>{item.problem}</span>
                </p>
              </div>
              <Link href={'#'}>
                <div className={styles.button}>詳しく見る</div>
              </Link>
              {/* <ul className={styles.casescard_label_category}>
                {item.tags.map((tagItem, index) => (
                  <li key={index}>
                    <Link href={tagItem.href}>{tagItem.tag}</Link>
                  </li>
                ))}
              </ul> */}
            </div>
          </div>
        ),
        // ),
      )}
    </Slider>
  )
}

export default MobileCaseStudyItem
